"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.newFactMetadataObject = exports.FactMetadataObjectBuilder = void 0;
var tslib_1 = require("tslib");
// (C) 2019-2020 GoodData Corporation
var identity_1 = tslib_1.__importDefault(require("lodash/identity"));
var factory_1 = require("./factory");
var builder_1 = require("../builder");
/**
 * Fact metadata object builder
 * See {@link Builder}
 *
 * @beta
 */
var FactMetadataObjectBuilder = /** @class */ (function (_super) {
    tslib_1.__extends(FactMetadataObjectBuilder, _super);
    function FactMetadataObjectBuilder() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return FactMetadataObjectBuilder;
}(factory_1.MetadataObjectBuilder));
exports.FactMetadataObjectBuilder = FactMetadataObjectBuilder;
/**
 * Fact metadata object factory
 *
 * @param ref - fact reference
 * @param modifications - fact builder modifications to perform
 * @returns created fact metadata object
 * @beta
 */
exports.newFactMetadataObject = function (ref, modifications) {
    if (modifications === void 0) { modifications = identity_1.default; }
    return builder_1.builderFactory(FactMetadataObjectBuilder, { type: "fact", ref: ref }, modifications);
};
//# sourceMappingURL=factFactory.js.map